import { useQuery } from '@tanstack/react-query';
import { useServices } from 'index';
import { UpgradeToPremium } from './UpgradeToPremium/UpgradeToPremium';
import { Certificates } from './Certificates/Certificates';
import { useTranslation } from 'react-i18next';
import { FAQ } from './FAQ/FAQ';
import { useEffect } from 'react';
import { useCartStore } from 'stores/SubscriptionsAndPricing/CartStore';
import { CartItem } from 'types/cart';

export const SubscriptionsAndPricingShop = () => {
  const { t } = useTranslation();

  const profileService = useServices().profileService;
  const { data, isPending } = useQuery({
    queryKey: ['isUserMember'],
    queryFn: profileService.checkIfUserIsMember,
    refetchOnWindowFocus: false,
  });

  const addItemToCart = useCartStore((state) => state.addItemToCart);
  const setInitialized = useCartStore((state) => state.setInitialized);
  const initialized = useCartStore((state) => state.initialized);

  useEffect(() => {
    if (!initialized) {
      const cartFromLocalStorage = localStorage.getItem('cart');
      if (cartFromLocalStorage) {
        const parsedCart = JSON.parse(cartFromLocalStorage);
        parsedCart.items.forEach((item: CartItem) => addItemToCart(item));
      }
      setInitialized(true);
    }
  }, [initialized, addItemToCart, setInitialized]);

  return (
    <>
      {!isPending ? (
        <div>
          {data ? null : <UpgradeToPremium />}
          <Certificates isPremiumUser={data ?? false} />
          <FAQ />
        </div>
      ) : null}
    </>
  );
};

export const subscription = { id: 'premium', title: 'Trackman University Subscription', basePrice: 175 };
